module.exports = __webpack_public_path__ + "img/826ba8d.png";